<template>
    <section class="uxo-item" v-if="terroristGroup">
        <template v-if="!fetchingTerroristGroup">
            <template v-if="terroristGroup.name">

                <div class="d-flex mb-2">
                    <h1 class="flex-grow w-100">{{terroristGroup.name}}</h1>
                    <div
                        :class="{ 'uxo-item__status--active' : terroristGroup.active }"
                        class="uxo-item__status">{{ terroristGroup.active ? 'Active' : 'Inactive' }}</div>
                </div>

                <div class="d-flex flex-column flex-lg-row mb-7">
                    <div class="uxo-item__gallery  mb-4 mr-md-3">
                        <template v-if="terroristGroup.images.length > 1">
                            <cat-uxo-carousel class="mb-3"
                                              v-if="user && (user.eod_technician || user.technical_interest)"
                                              :starting-image="0"
                                              :slides="terroristGroup.images"
                            ></cat-uxo-carousel>
                        </template>

                        <div v-if="!user || terroristGroup.images.length === 1"
                             class="uxo-list__image d-flex justify-content-center d-md-block">
                            <img v-if="terroristGroup.images[0]" class="image w-auto align-self-center mb-3 border-radius"
                                 :src="terroristGroup.images[0].aws_url" :alt="terroristGroup.name"/>
                        </div>

                        <div v-if="user && user.guest">
                            <template v-if="terroristGroup.images.length >= 1">
                                <img v-if="terroristGroup.images[0]" class="image border-radius w-auto align-self-center mb-3"
                                     :src="terroristGroup.images[0].aws_url" :alt="terroristGroup.name"/>
                            </template>
                        </div>

                        <cat-uxo-contribute
                            :contribution-type="7"
                            :contribution-model="terroristGroup"
                            v-if="user && (user.eod_technician || user.technical_interest)" :user="user"
                            :button="'Contribute Information'"></cat-uxo-contribute>
                        <a v-else href="/sign-up" class="btn w-100">Sign Up</a>

                    </div>

                    <div class="uxo-item__content">
                        <h2 class="font-weight-normal mb-2">Established</h2>
                        <p>{{ terroristGroup.established }}</p>

                        <h2 class="font-weight-normal mb-2">Numbers</h2>
                        <p class="mb-3">{{ terroristGroup.numbers }}</p>

                        <h2 class="font-weight-normal uxo-item__section-heading">Goal</h2>
                        <div class="rich-content" v-html="terroristGroup.goal_html"></div>

                    </div>

                </div>

                <div class="uxo-item__operation mb-3">
                    <div class="uxo-item__content uxo-item__content--full">
                        <h3 class="uxo-item__section-heading">Description</h3>
                        <div class="rich-content" v-html="terroristGroup.description_html"></div>
                    </div>
                </div>

                <div class="d-flex flex-column" v-if="user">

                    <div class="uxo-item__operation mb-3" v-if="(user.eod_technician || user.technical_interest) && terroristGroup.further_information_html">
                        <div class="uxo-item__content uxo-item__content--full" v-if="terroristGroup.further_information_html">
                            <h3 class="uxo-item__section-heading">Further Information</h3>
                            <div class="rich-content" v-html="terroristGroup.further_information_html"></div>
                        </div>
                    </div>

                    <div class="uxo-item__operation mb-3" v-if="(user.eod_technician) && terroristGroup.analysis_html">
                        <div class="uxo-item__content uxo-item__content--full" v-if="terroristGroup.analysis_html">
                            <h3 class="uxo-item__section-heading">Analysis</h3>
                            <div class="rich-content" v-html="terroristGroup.analysis_html"></div>
                        </div>
                    </div>
                </div>

                <cat-uxo-supporter-contributions
                    :contribution-model="terroristGroup"
                    :contribution-type="7"
                    :user="user"
                    v-if="user && (user.eod_technician || user.technical_interest)"></cat-uxo-supporter-contributions>

                <cat-uxo-linear-ads class="mb-10"></cat-uxo-linear-ads>
                <div v-if="!user || (user && user.guest)" class="call-to-action-wrap">
                    <div class="d-sm-flex columns justify-content-between mb-8">
                        <div class="d-flex w-50 mr-sm-3 mb-3 mb-sm-0">
                            <cat-uxo-call-to-action class="d-flex h-100 shape--uxo-item"></cat-uxo-call-to-action>
                        </div>
                        <div class="d-flex w-50">
                            <cat-uxo-call-to-action-outline class="d-flex h-100"></cat-uxo-call-to-action-outline>
                        </div>
                    </div>
                </div>

                <div class="associated-associatedHazards mt-8" v-if="terroristGroup.hazards.length > 0">
                    <h2 class="t-orange text-center mb-3">Associated Hazards</h2>
                    <div class="uxo-list columns is-multiline is-mobile mb-5">
                        <template v-for="(associatedHazard) in terroristGroup.hazards">
                            <div class="column is-4-mobile is-2-tablet mb-1">
                                <a class="uxo-list__item" :href="associatedHazard.url">
                                    <img class="image mb-1" v-if="associatedHazard.images && associatedHazard.images[0]" :src="associatedHazard.images[0].aws_url"
                                         :alt="associatedHazard.name"/>
                                    <h5 class="font-weight-normal">{{associatedHazard.name}}</h5>
                                </a>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="associated-associatedHazards mt-8" v-if="terroristGroup.incidents.length > 0">
                    <h2 class="t-orange text-center mb-3">Associated IED Incidents</h2>
                    <div class="uxo-list columns is-multiline is-mobile mb-5">
                        <template v-for="(associatedIncident) in terroristGroup.incidents">
                            <div class="column is-4-mobile is-2-tablet mb-1">
                                <a class="uxo-list__item" :href="`../incidents/${associatedIncident.slug}`">
                                    <img class="image mb-1" v-if="associatedIncident.images && associatedIncident.images[0]" :src="associatedIncident.images[0].aws_url"
                                         :alt="associatedIncident.name"/>
                                    <h5 class="font-weight-normal">{{associatedIncident.name}}</h5>
                                </a>
                            </div>
                        </template>
                    </div>
                </div>

            </template>
            <template v-else>
                <h2>The Terrorist Group you are looking for could not be found.</h2>
            </template>
        </template>
        <template v-else>
            <div class="content-loader">
                <ContentLoader
                    :height="56"
                    :width="720"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="16" y="0" rx="5" ry="5" width="300" height="40"/>
                </ContentLoader>
                <ContentLoader
                    :height="352"
                    :width="720"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                    class="mb-2"
                >
                    <rect x="16" y="0" rx="0" ry="0" width="300" height="300"/>
                    <rect x="340" y="0" rx="5" ry="5" width="200" height="20"/>
                    <rect x="340" y="56" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="72" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="88" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="104" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="136" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="152" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="168" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="184" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="200" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="216" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="232" rx="5" ry="5" width="380" height="6.4"/>
                </ContentLoader>
            </div>
        </template>
    </section>
</template>

<script>
    import CatUxoContribute from '@/js/components/shared/Contribute';
    import CatUxoCarousel from '@/js/components/shared/Carousel';
    import {mapActions, mapState} from "vuex";
    import {ContentLoader} from 'vue-content-loader';
    import truncate from 'vue-truncate-collapsed';
    import LinearAds from "../shared/LinearAds";

    export default {
        name: 'CatUxoTerroristGroup',
        props: {
            user: {
                type: Object,
                required: false
            },
            slug: {
                type: String,
                required: true
            },
        },
        components: {
            CatUxoContribute,
            CatUxoCarousel,
            ContentLoader,
            truncate,
            LinearAds,
        },
        data() {
            return {}
        },
        computed: {
            ...mapState('terroristGroups', [
                'terroristGroup',
                'fetchingTerroristGroup'
            ]),
            images: function () {
                let urls = [];
                this.terroristGroup.images.forEach(function (image) {
                    if (image.aws_url) {
                        urls.push(image.aws_url);
                    }
                });

                return urls;
            }
        },
        methods: {
            ...mapActions('terroristGroups', [
                'fetchTerroristGroup'
            ]),
        },
        created() {
            this.fetchTerroristGroup({slug: this.slug})
        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>

    .uxo-item__content {
        overflow: auto;
    }

    .uxo-item__eod-warning {
        background: $c-white;
        color: $c-orange;
        font-weight: normal;
        line-height: $lh-lg;
        font-size: $fs-18;
    }

    @include media-breakpoint-down(sm) {
        .call-to-action-wrap {
            .w-50 {
                width: 100% !important;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/uxo/TerroristGroup.vue